import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import UserList from '../components/users/UserList'
import { useGetUserInfo } from '../hooks/useGetUserInfo'
import { useIsSecurityUserWithLoading } from '../hooks/useIsSecurityUserWithLoading'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { paths } from '../utils/paths'

export default function UsersPage() {
  const history = useHistory()

  const { isSecurityUser, loading } = useIsSecurityUserWithLoading()
  const userInfo = useGetUserInfo()

  if (loading) return null

  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        {isSecurityUser && (
          <UserList
            building={userInfo?.building}
            redirectTo={history.location.pathname}
            showOnlyUsers={true}
            isSecurityUser={isSecurityUser}
          />
        )}
        {!isSecurityUser && <UserList redirectTo={history.location.pathname} />}
      </Container>
    </main>
  )
}
